import { Typography } from '@mui/material';
import { styled } from '@mui/styles';
import React from 'react';
import { CalendarJobType } from './calendar-job-type';

export type GridDepartmentProps = {
  department: {
    id: string;
    name: string;
    jobTypes: {
      id: string;
      name: string;
      shifts: {
        applicants: number;
        claimants: number;
        jobName: string;
        flexPoolOnly: boolean;
        dateLabel: string;
        dateTime: string;
        endTime: string;
        id: string;
        maxClaimants: number;
        startTime: string;
        hasCanceledClaim: boolean;
      }[];
    }[];
  };
};

export const CalendarDepartment = React.memo(
  ({ department }: GridDepartmentProps) => {
    return (
      <Section>
        <StyledName title={department.name}>{department.name}</StyledName>
        {department.jobTypes.length ? (
          department.jobTypes.map((jobType) => (
            <CalendarJobType key={jobType.id} jobType={jobType} />
          ))
        ) : (
          <CalendarJobType jobType={undefined} />
        )}
      </Section>
    );
  },
  (prev, next) => {
    if (prev.department.id !== next.department.id) {
      return false;
    }
    if (prev.department.jobTypes.length !== next.department.jobTypes.length) {
      return false;
    }
    if (JSON.stringify(prev.department) !== JSON.stringify(next.department)) {
      return false;
    }
    return true;
  }
);

const Section = styled('section')(({ theme }) => ({
  minHeight: theme.spacing(8),
}));

const StyledName = styled(Typography)(() => ({
  fontWeight: 700,
  width: '14vw',
  position: 'relative',
  transform: 'translateY(-20%)',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'pre',
}));
